module.exports = __webpack_public_path__ + "static/img/exam_4.b98d96a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webSite/exam_4.png
// module id = 7bm5
// module chunks = 1